module.exports = __webpack_public_path__ + "img/中国搜索_01.2af2753a.jpg";